import {Component, Input, OnInit} from '@angular/core';
import { environment } from '../../../../environments/environment';
import detectMobile from 'src/app/utils/detect-mobile';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-registration-progress-bar',
  templateUrl: './registration-progress-bar.component.html',
  styleUrls: ['./registration-progress-bar.component.sass'],
})
export class RegistrationProgressBarComponent implements OnInit {
  public brand;
  @Input() activeIndex: number = 1;

  public isMobile = detectMobile();

  items: MenuItem[];

  constructor() {}

  ngOnInit() {
    this.items = [
      {
        label: 'Контактная информация',
      },
      { label: 'Паспорт и адрес' },
      { label: 'Общие сведения' },
    ];

    this.brand = environment.brand;
  }
}
